import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEOService } from "../services/seoService";

export const useDynamicSEO = () => {
  const [seoSettings, setSeoSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const loadSEOSettings = async () => {
      try {
        setLoading(true);
        setError(null);

        const currentPath = location.pathname;
        const settings = await SEOService.getActiveSEOSettings(currentPath);

        if (settings) {
          setSeoSettings(settings);
        } else {
          // Try to get default settings for the root path
          const defaultSettings = await SEOService.getActiveSEOSettings("/");
          setSeoSettings(defaultSettings);
        }
      } catch (err) {
        console.error("Error loading SEO settings:", err);
        setError("Failed to load SEO settings");
      } finally {
        setLoading(false);
      }
    };

    loadSEOSettings();
  }, [location.pathname]);

  return {
    seoSettings,
    loading,
    error,
    hasSettings: !!seoSettings,
  };
};
